import clsx from "clsx";
import * as React from "react";
import { Text, type TextProps } from "../text/Text.js";

type DividerElement = React.ElementRef<"div">;

interface BaseDividerProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: "horizontal" | "vertical";
  textProps?: TextProps;
  textWrapperClassName?: string;
}

interface HorizontalDividerProps extends BaseDividerProps {
  orientation?: "horizontal";
  text?: string;
}

interface VerticalDividerProps extends BaseDividerProps {
  orientation: "vertical";
  text?: never;
}

type DividerProps = HorizontalDividerProps | VerticalDividerProps;

const Divider = React.forwardRef<DividerElement, DividerProps>((props, ref) => {
  const {
    orientation = "horizontal",
    text,
    textProps = {
      size: "md",
    },
    textWrapperClassName,
    className,
    ...rest
  } = props;

  return (
    <React.Fragment>
      {orientation === "horizontal" && text ? (
        <div
          data-orientation={orientation}
          data-text={true}
          className="ox-reset ox-DividerWithText"
        >
          <div
            data-orientation={orientation}
            className="ox-reset ox-ui-Divider"
            {...rest}
            ref={ref}
          />
          <Text {...textProps}>{text}</Text>
          <div
            data-orientation={orientation}
            className="ox-reset ox-ui-Divider"
            {...rest}
            ref={ref}
          />
        </div>
      ) : (
        <div
          data-orientation={orientation}
          className={clsx("ox-reset ox-ui-Divider", className)}
          {...rest}
          ref={ref}
        />
      )}
    </React.Fragment>
  );
});

Divider.displayName = "Divider";
export { Divider };
export type { DividerProps };
